// gerekceKurali.js — GEREKÇE KURALI, SAF (21 Eki 2026, K7)
//
// 🔑 Serkan: *"boş olmasın, en az 3 — hepsi için geçerli olsun, belki ileride kısaltma oluştururuz, o kapıdan geçebilecek"*.
//    Bütün gerekçe pencereleri ve formlardaki gerekçe alanları bu kuralı kullanır (pencere ve ipucu satırı `gerekce.js`te).
//    React'siz: alan listeleri (`ucakTipleri.js`, AIRPORTS) de buradan okur.

export const GEREKCE_ASGARI = 3;
/** Gerekçe yeterli mi — boşluklar atılınca en az 3 karakter (TRAINING tablolarının veritabanı sınırıyla aynı). */
export const gerekceTamam = (t) => String(t ?? '').trim().length >= GEREKCE_ASGARI;
/** Kutunun altındaki satırın ve kapı uyarısının metni. */
export const gerekceIpucuMetni = (t) => (gerekceTamam(t)
  ? `${String(t).trim().length} characters`
  : `At least ${GEREKCE_ASGARI} characters — the reason goes to the audit trail and cannot be deleted.`);
